import { jsx as _jsx } from 'react/jsx-runtime'
import { getCxmFilmsForComponent, getFilmsByIds, LoadingState } from '@vista/omnichannel-components-domain'
import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { observer } from 'mobx-react'
import { useContext } from 'react'
import { useI18n } from '../../../context/occ/hooks/use-i18n'
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config'
import { sortAndSliceFilms } from '../../../utils/film-sort-utils'
import { ShowtimePickerContextInstance } from '../types/context'
import { getFilmListItemElementId } from '../utils/get-film-list-item-element-id'
import { ShowtimePickerFilm } from './film'
import { ShowtimePickerFilmListSkeleton } from './film-list-skeleton'

const b = bemClassBuilder('v-showtime-picker-film-list')
export const ShowtimePickerFilmList = observer(() => {
    const i18n = useI18n()
    const { enableSkeletonLoadingIndicators } = useOccConfig()
    const {
        config,
        filmIds,
        siteIds,
        showtimes,
        filmsLoadingState,
        getNoShowtimesForSiteDisplayTextProps,
        displayText,
    } = useContext(ShowtimePickerContextInstance)
    const { filmDetails, showSiteDetails, componentId } = config
    const films = getFilmsByIds(filmIds)
    const cxmFilms = componentId ? getCxmFilmsForComponent(componentId) : undefined
    const sortedFilms = sortAndSliceFilms(films, i18n, cxmFilms)

    // HACK: Created function filmWithNoShowtimesClass, to return 'film-with-no-showtime' if film has no showtimes.
    const filmWithNoShowtimesClass = filmId => {
        const filmShowTimes = showtimes.filter(showtime => showtime.filmId === filmId)
        return !filmShowTimes.length &&
            getNoShowtimesForSiteDisplayTextProps &&
            siteIds.every(siteId => {
                const value = getNoShowtimesForSiteDisplayTextProps(siteId, filmId)
                return value && value.label === displayText.noShowtimesForSiteAndFilmMessage
            })
            ? ' film-with-no-showtimes'
            : ''
    }

    switch (filmsLoadingState) {
        case LoadingState.Success:
            return _jsx(
                'ul',
                Object.assign(
                    { className: b.block() },
                    {
                        children: sortedFilms.map(film =>
                            _jsx(
                                'li',
                                Object.assign(
                                    {
                                        // HACK: run filmWithNoShowtimesClass to return 'film-with-no-showtimes' or ''
                                        className: b.element('item' + filmWithNoShowtimesClass(film.id)),
                                        id: getFilmListItemElementId(film.id),
                                    },
                                    {
                                        children: _jsx(ShowtimePickerFilm, {
                                            film: film,
                                            showtimes: showtimes.filter(showtime => showtime.filmId === film.id),
                                        }),
                                    }
                                ),
                                film.id
                            )
                        ),
                    }
                )
            )
        case LoadingState.NotLoaded:
        case LoadingState.Loading: {
            return enableSkeletonLoadingIndicators
                ? _jsx(ShowtimePickerFilmListSkeleton, {
                      numberOfFilms: filmIds.length > 0 ? filmIds.length : 2,
                      numberOfSites: siteIds.length > 0 ? siteIds.length : 2,
                      showFilmDetails: filmDetails.show,
                      showSiteDetails: showSiteDetails,
                      filmMediaType: filmDetails.mediaType,
                  })
                : null
        }
        default:
            return null
    }
})
ShowtimePickerFilmList.displayName = 'ShowtimePickerFilmList'
